

/** 
 * TODO
 * For the future, differentiate font, height, width and etc
 * **/
import { Dimensions, PixelRatio } from "react-native";

 

// Reference screen dimensions (Default: iPhone 12, 844x390)
const BASE_WIDTH = 390;
const BASE_HEIGHT = 844;

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get("window");

// Factor to normalize scaling across devices
const SCALE_WIDTH = SCREEN_WIDTH / BASE_WIDTH;
const SCALE_HEIGHT = SCREEN_HEIGHT / BASE_HEIGHT;
const SCALE_FACTOR = Math.min(SCALE_WIDTH, SCALE_HEIGHT);

/**
 * Scale for all UI elements proportionally (width, height, padding, etc.).
 * @param {number} size - The base size in design reference (e.g., 16px).
 * @returns {number} - Scaled size for current screen.
 */
export const scaleAll_ = (size: number) => PixelRatio.roundToNearestPixel(size * SCALE_FACTOR);

/**
 * Scale for fonts only (ensures readability across devices).
 * @param {number} fontSize - The font size in design reference.
 * @returns {number} - Adjusted font size.
 */
export const scaleFont_ = (fontSize: number) => PixelRatio.roundToNearestPixel(fontSize * SCALE_FACTOR);

/**
 * Get vertical scaling for height adjustments.
 * @param {number} size - Base height.
 * @returns {number} - Scaled height.
 */
export const verticalScale_ = (size: number) => PixelRatio.roundToNearestPixel(size * SCALE_HEIGHT);

/**
 * Get horizontal scaling for width adjustments.
 * @param {number} size - Base width.
 * @returns {number} - Scaled width.
 */
export const horizontalScale_ = (size: number) => PixelRatio.roundToNearestPixel(size * SCALE_WIDTH);



export const maxScale = (x: number) => Math.max(scaleAll_(x), horizontalScale_(x), verticalScale_(x))
export const minScale = (x: number) => Math.min(scaleAll_(x), horizontalScale_(x), verticalScale_(x))